import createOrder from '@/translations/en/orders/create-order';
import createBulkOrder from '@/translations/en/orders/create-bulk-order';
import createOrderRework from '@/translations/en/orders/create-order-rework';
import orderDrawer from '@/translations/en/orders/order-drawer';
export default {
  deposits: 'Deposits',
  retentions: 'Retentions',
  paymentType: 'Payment type',
  orderList: {
    returns: 'Returns',
    emptyLine1: 'You currently have no {type}',
    emptyState: {
      title: 'No {type} yet',
      description: 'Create new {type} to request materials.',
      siteDescription: "Create a new {type} to request materials against this site's BOQ.",
      filteredTitle: 'No {type} matching your filters',
      filteredDescription: 'Try adjusting or clearing your filters to see more.',
    },
    errorState: {
      title: 'Unable to load {type}',
      description: 'Something went wrong while loading. Please try again.',
    },
    order: 'Order',
    claim: 'Claim',
    completeClaim: 'Complete Claim',
    filterBar: {
      search: 'Search by {type} ID',
      /**
       * Replaces `search` on the Orders tab while bulk orders are on. Without it nothing tells a
       * user the capability exists — and the Type filter was cut at review (DL-36) precisely
       * because search already covers the need, which only holds if the control says so.
       */
      searchWithBulk: 'Search by order or bulk order ID',
      site: 'Site',
      vendor: 'Vendor',
      status: 'Status',
      payment: 'Payment',
      dateRange: 'Date range',
      clear: 'Clear filters',
    },
    headers: {
      orderId: '{type} ID',
      site: 'Site',
      vendor: 'Vendor',
      placed: 'Placed',
      status: 'Status',
      payment: 'Payment',
      ordered: 'Ordered',
      vendorNotified: 'Vendor Notified',
      amount: 'Amount',
      context: 'Context',
      select: 'Select',
      amountInclVat: 'Amount (Incl. VAT)',
    },
    contextMenu: {
      view: 'View {type} details',
      cancel: 'Cancel {type}',
      complete: 'Complete {type}',
      approve: 'Approve {type}',
      decline: 'Decline {type}',
      logDelivery: 'Log delivery',
      issueReturn: 'Issue a return',
    },
    reviewComment: 'Review Comment',
    yes: 'Yes',
    no: 'No',
    loading: '-',
    view: 'View',
    loadingPayments: 'Loading…',
    noPaymentRequests: 'No payment requests',
  },
  orderDetails: {
    orderRequest: '{type} Request',
    // Placeholder copy for the flagged order/claim drawer split (PLE-1210); replaced when
    // each drawer gets its real content.
    drawerSplitStub: {
      title: 'Dedicated {type} drawer',
      description: 'This drawer now holds {type} logic only. Its content arrives in the next step.',
    },
    noPayments: 'There are no payment requests linked to this claim.',
    detailsSection: {
      title: '{type} Summary',
      subTitle: 'Details and vendor information related to this {type}',
      details: '{type} details',
      siteName: 'Site name',
      deliveryDate: 'Delivery date',
      claimPeriod: 'Claim period',
      deposit: 'Deposit amount',
      claimPeriodPeriods: '{period} of {totalPeriods}',
      completionComments: 'Completion comments',
      notes: '{type} notes',
      history: '{type} history',
      requested: 'Requested by',
      requestedOn: 'Requested on',
      requestedBy: '{name} on {date} at {time}',
      completed: 'Completed by',
      completedBy: '{name} on {date} at {time}',
      approved: 'Approved by',
      delivered: 'Delivered on',
      deliveredOn: '{date} at {time}',
      vendorDetails: 'Vendor details',
      vendorName: 'Vendor name',
      vendorEmail: 'Vendor email',
      vendorNumber: 'Vendor contact number',
      vendorLandline: 'Vendor landline number',
      vendorAccountType: 'Vendor account type',
      ordered: 'Ordered',
      vendorNotified: 'Vendor notified',
    },
    uploadSection: {
      documentation: {
        title: 'Documentation',
        subTitle: 'Documentation added or generated through this {type}.',
        noDocumentation:
          'No documentation added. A claim certificate will be generated on approval of this claim',
        placeholder: 'No documentation added',
      },
      keyDocumentation: {
        title: 'Key documentation',
        subTitle:
          'All documents required for the completion of this {type} and its associated payments.',
        subTitleComplete: 'Order prerequisites, Payment prerequisites',
        missingDocs: 'The following documents are required for this request to be completed',
        allDocsCompleted: 'All required documentation for this request has been completed',
        createdBeforeKeyDocs:
          "Note: This request was created before the Key Documentation update. Requirements may appear as 'Missing' if documents were uploaded as generic types. Please check the Additional Documentation section below for existing files.",
      },
      additionalDocumentation: {
        title: 'Additional documentation',
        subTitle: 'Additional documentation added or generated through this {type}.',
      },
      title: '{type} documentation',
      label: 'uploadSection',
      proofDelivery: 'Upload proof of delivery',
      toast: {
        upload: {
          success: {
            title: 'Document uploaded',
            content: 'The document has been successfully uploaded',
          },
          error: {
            title: 'Error',
            content: 'An error occurred while uploading the document',
          },
        },
        delete: {
          success: {
            title: 'Document deleted',
            content: 'The document has been successfully deleted',
          },
          error: {
            title: 'Error',
            content: 'An error occurred while deleting the document',
          },
        },
      },
    },
    declineReason: 'Reason for decline',
    inventorySection: {
      title: '{type} Inventory',
      subTitle: 'Items included in this {type}',
      headers: {
        itemName: 'Item name',
        specification: 'Spec',
        boq: 'BOQ section',
        vo: 'VO',
        unit: 'Unit',
        previous: 'Previous',
        now: 'Now',
        rate: 'Rate',
        total: 'Total',
        delivered: 'Delivered',
        actions: 'Actions',
      },
      // The figures a pending variation is asking for, shown under the current value on the
      // warn-marked row rather than on a second row of their own.
      requested: 'Requested {value}',
      rows: {
        total: 'Order Total',
        inclVat: 'Total Incl VAT',
        vatByLine:
          'VAT registered vendors will have their allocated VAT % added to their total price',
        itemRemoved: 'Item removed due to VO decline',
      },
      buttons: {
        approveOrder: 'Approve {type}',
        declineOrder: 'Decline {type}',
        deny: 'Deny',
        approve: 'Approve',
      },
      returnLogged: 'Return logged',
      returnCancelled: 'Return cancelled',
    },
  },
  paymentDetails: {
    paymentSummary: {
      title: 'Payment Summary',
      subTitle: 'All details related to this payment request',
    },
    totals: {
      breakdown: 'Payment breakdown',
      requestTotal: 'Request Total',
      amountExl: 'Amount excl',
      vat: 'Vat amount',
      adjustment: 'Payment adjustment {date}',
      total: 'Total (VAT incl)',
    },
    orderSummary: {
      title: 'Order Summary',
      subTitle: 'All details related to this payment request',
    },
    order: {
      vendor: 'Vendor',
      siteName: 'Site name',
      deliveryDate: 'Delivery date',
      notes: 'Notes',
    },
  },
  logDelivery: {
    orderInventory: {
      title: 'Order Inventory',
      subTitle: 'Complete the item quantity and rates delivered.',
      headers: {
        itemName: 'Item name',
        specification: 'Specification',
        sku: 'SKU',
        unit: 'Unit',
        quantity: 'Qty',
        rate: 'Rate',
        amount: 'Amount',
      },
      row: 'Order Total',
      exceedsRemainingQty: 'Exceeds remaining qty ({qty})',
    },
    documentUpload: {
      title: 'Order documentation',
      subTitle: 'Add your proof of this delivery',
      button: 'Upload',
      placeholder: 'Upload proof of delivery',
    },
    button: 'Confirm delivery',
  },
  issueReturn: {
    title: 'Issue a return',
    subtitle: 'Select the order item and enter the return quantity you wish to issue',
    totalReturned: 'Total Returned',
    refundType: {
      title: 'Refund Type',
      info: 'The following refund types are available for this return.',
      selectType: 'Select a refund type',
      fullRefund: {
        title: 'Get refund',
        info: 'The full value of the return will be refunded from the vendor',
      },
      priceAdjustment: {
        title: 'Price adjustment',
        info: 'The existing payment request will be adjusted',
      },
      credit: {
        title: 'Apply as vendor credit',
        info: 'Credit will be assigned to the vendor account for upcoming payments',
      },
    },
    returnNote: {
      title: 'Return Note',
      info: 'Add a return note for review',
      placeholder: 'Write a note',
    },
    itemTable: {
      headers: {
        deliveryDate: 'Delivery date',
        sku: 'SKU',
        unit: 'Unit',
        qty: 'Qty',
        rate: 'Rate',
        returningQty: 'Returning Qty',
      },
      enterQty: 'Enter qty',
      pendingDelivery: 'Pending delivery',
    },
    buttons: {
      cancelReturn: 'Cancel return',
      confirmReturn: 'Confirm return',
    },
  },
  claimCompletion: {
    title: 'Upload proof of completion',
    subtitle: 'Upload documentation that verifies the scope of this claim has been completed.',
    notes: 'Additional notes (Optional)',
    notesPlaceholder: 'Type your notes here...',
    confirmationCheckbox: 'I confirm that the task has been reviewed and is now complete.',
    required: 'Required',
    buttons: {
      confirm: 'Confirm completion',
      return: 'Return',
    },
  },
  // The shared approve and deny confirm for a variation, opened from the BOQ line, the order
  // drawer and the bulk order hub (PE-960). Scope copy states what each choice does and steers
  // toward neither (DL-150).
  variationConfirm: {
    title: {
      approve: 'Approve variation',
      deny: 'Deny variation',
    },
    lead: {
      approve: 'Approve the variation on {item}?',
      deny: 'Deny the variation on {item}?',
    },
    bulkContext: 'Part of bulk order {reference}.',
    bulkContextGating:
      'Part of bulk order {reference}. It blocks approval of the bulk order until it is resolved.',
    scope: {
      label: 'Does approving change the BOQ line rate?',
      required: 'Choose whether the new rate is permanent or for this order only.',
      permanent: {
        label: 'Update the line rate permanently',
        description: "The BOQ line rate becomes {orderRate} for the line's outstanding quantity.",
      },
      thisOrderOnly: {
        label: 'This order only',
        description:
          'The BOQ line rate stays {lineRate}. Only this order is priced at {orderRate}.',
      },
      movement: 'Moves the BOQ line total by {amount}',
      inputs:
        'This order takes {orderQuantity} at {orderRate}. The line rate is {lineRate}, with {outstandingQuantity} outstanding on the line.',
    },
    deny: {
      reasonLabel: 'Reason for denying',
      reasonRequired: 'Give a reason for denying this variation.',
      lastLine: "If this is the site order's only line, denying cancels that order.",
    },
    approver: {
      approve: 'Approving as {name}',
      deny: 'Denying as {name}',
    },
    submit: {
      approve: 'Approve',
      deny: 'Deny',
    },
    cancel: 'Cancel',
    error: 'The variation could not be updated. Try again.',
  },
  modals: {
    deleteDocument: {
      title: 'Delete document',
      content: 'Are you sure you want to delete this document?',
      warning: 'This action is irreversible',
      buttons: {
        decline: 'No, cancel',
        accept: 'Yes, remove',
      },
    },
    pendingVariations: {
      title: 'Pending {type} variations',
      content:
        'This {type} has pending BOQ variations on some items. Approving this {type} will approve all pending variations. Are you sure you wish to approve the {type}?',
      warning: 'This will update the line items in the associated BOQ',
      buttons: {
        decline: 'No, cancel',
        accept: 'Yes, approve',
      },
    },
    approveOrder: {
      title: 'Approve {type}',
      content: 'Approving this {type} will create a payment request for approved items',
      vendorEmail: 'Send this {type} to vendor on approval',
      // How to fix a vendor with no email depends on who keeps its details (DL-263): an org edits its
      // custom vendors, while BOQNET keeps a synced Budget Control vendor's.
      noVendorEmail:
        'This vendor has no email address. Add one on the Vendors page to notify them.',
      noVendorEmailSynced:
        'This vendor has no email address. Ask BOQNET support to add one to notify them.',
      vendorName: 'Vendor name',
      vendorSalesEmail: 'Vendor sales email',
      buttons: {
        decline: 'No, cancel',
        accept: 'Yes, approve',
      },
    },
    declineOrder: {
      title: 'Decline {type}',
      content: 'Please provide a reason for declining this {type}',
      label: 'Reason',
      field: 'Write your reason here...',
      buttons: {
        accept: 'Confirm',
      },
    },
    cancelOrder: {
      title: 'Cancel {type}',
      content:
        'Cancelling this {type} will notify the vendor of its cancellation, and cancel any unpaid payment requests tied to it. Are you sure?',
      warning: 'This action is irreversible',
      // Context: shown on every cancel, as the bulk cancel's deposit line is, whether or not anything is paid.
      creditWarning: 'Anything already paid on this {type} automatically raises a Credit Request.',
      awaitingProof:
        '{payment} is awaiting proof for this {type}. Upload its proof or cancel the payment first.',
      // Only someone who logs payments can upload a payment's proof or cancel it (FR-L10).
      awaitingProofNoLogPayment:
        '{payment} is awaiting proof for this {type}. Someone who logs payments must upload its proof or cancel it first.',
      buttons: {
        decline: 'No, keep {type}',
        accept: 'Yes, cancel {type}',
      },
    },
    completeOrder: {
      title: 'Complete {type}',
      content: 'Are you sure you want to complete this {type}?',
      buttons: {
        decline: 'No, cancel',
        accept: 'Yes, complete',
      },
    },
    emailVendor: {
      title: 'Email to Vendor',
      content:
        'This will send an email to the order vendor of this particular order. Are you sure?',
      buttons: {
        decline: 'No, cancel',
        accept: 'Yes, send now',
      },
    },
    changeSiteDates: {
      title: 'Approval Date Outside Site Dates',
      content: 'Approving this order will update the site dates. Are you sure you want to proceed?',
      contentWithReason:
        "Approving this order will update the site dates. The reason is saved to the site's activity log.",
      contentWithReasonClaim:
        "Approving this claim will update the site dates. The reason is saved to the site's activity log.",
      reasonLabel: 'Reason',
      reasonPlaceholder: 'Why is this order outside the site dates?',
      reasonPlaceholderClaim: 'Why is this claim outside the site dates?',
      buttons: {
        decline: 'No, cancel',
        accept: 'Yes, approve',
      },
    },
    returnAllUndeliveredItems: {
      title: 'Return Not Allowed',
      content:
        'No items in this order have been delivered yet.\nReturning all remaining items will cancel the order instead.\n\nDo you want to cancel this order?',
      buttons: {
        decline: 'No, go back',
        accept: 'Yes, cancel order',
      },
    },
  },
  toasts: {
    approve: {
      success: {
        title: 'Order approved',
        content: 'Order has been successfully approved',
      },
      error: {
        title: 'Error',
        content: 'An error occurred while approving the order',
      },
    },
    decline: {
      success: {
        title: 'Order declined',
        content: 'Order has been declined successfully',
      },
      error: {
        title: 'Error',
        content: 'An error occurred while declining the order',
      },
    },
    cancel: {
      success: {
        title: 'Order cancelled',
        content: 'Order has been cancelled successfully',
      },
      error: {
        title: 'Error',
        content: 'An error occurred while cancelling the order',
      },
    },
    complete: {
      success: {
        title: 'Order completed',
        content: 'Order has been completed successfully',
      },
      error: {
        title: 'Error',
        content: 'An error occurred while completing the order',
      },
    },
    delivery: {
      success: {
        title: 'Order delivery logged',
        content: 'Order delivery has been successfully logged',
      },
      error: {
        title: 'Error',
        content: 'An error occurred while logging the delivery',
      },
    },
    exportSuccess: {
      title: 'Order exported',
      content: 'Order has been successfully exported',
    },
    shareSuccess: {
      title: 'Order shared',
      content: 'Order has been shared successfully',
    },
    vendorNotified: {
      success: {
        title: 'Vendor notified status updated',
      },
      error: {
        title: 'Error',
        content: 'An error occurred while updating the vendor notified status',
      },
    },
  },
  buttons: {
    issueReturn: 'Issue a return',
    logDelivery: 'Log a delivery',
    completeClaim: 'Complete Claim',
    cancelOrder: 'Cancel {type}',
    completeOrder: 'Complete {type}',
    declineOrder: 'Decline {type}',
    approveOrder: 'Approve {type}',
    confirmDelivery: 'Confirm delivery',
    exportPDF: 'Save as PDF',
    shareVendor: 'Email {type} to vendor',
    shareMyself: 'Email {type} to myself',
  },
  cards: {
    pendingOrderTotal: 'Pending order total',
    approvedOrderTotal: 'Approved order total',
    noRequestedOrders: 'No. of requested orders',
    inclVat: 'Incl. VAT',
  },
  createClaim: {
    title: '{type} New Claim',
  },
  createOrder,
  createOrderRework,
  createBulkOrder,
  orderDrawer,
  failedRequests: {
    orderDetails: 'Could not load order details. Please try again.',
  },
  bulkOrders: {
    tabLabel: 'Bulk Orders',
    createButton: 'Create New Bulk Order',
    createButtonShort: 'Bulk Order',
    /**
    The viewer tier's reason, exposed to assistive tech as well as on hover (FR-16).
    */
    createDisabledReason: 'Only Project Procurement Officers can create bulk orders',
    empty: {
      title: 'No bulk orders yet',
      description: 'Create a bulk order to place items across multiple sites at once.',
    },
    error: {
      title: 'Could not load bulk orders',
      description: 'Something went wrong loading this list. Please try again.',
    },
    /**
     * A filter matched nothing — distinct from having no bulk orders at all. Worded to match the
     * orders list's own filtered-empty copy (`orderList.emptyState.filteredTitle`) so the two tabs
     * read the same.
     */
    noMatches: {
      title: 'No bulk orders matching your filters',
      description: 'Try adjusting or clearing your filters to see more.',
    },
    headers: {
      reference: 'Bulk order ID',
      project: 'Project',
      vendor: 'Vendor',
      status: 'Status',
      siteCount: 'Number of sites',
      placed: 'Placed',
      total: 'Total incl VAT',
      vendorNotified: 'Vendor notified',
    },
    /**
    The list's Vendor notified control, named for the row it changes (PE-1349).
    */
    vendorNotifiedAccessible: 'Vendor notified for bulk order {reference}: {value}',
    // The record's noun in the copy bulk orders share with orders and claims ("Email {type} to
    // vendor", "Send this {type} to vendor on approval").
    recordNoun: 'bulk order',
    contextMenu: {
      view: 'View bulk order details',
      approve: 'Approve bulk order',
    },
    /**
    Whole-row severity on a parent held up by an unresolved gating variation.
    */
    blockedTooltip: 'Blocked: a variation on one or more sites needs approval',
    /**
    Names the dash a bulk order's total shows while it has none, for assistive tech.
    */
    noTotal: 'No total available',
    /**
    The same treatment on a parent whose decline or cancellation stopped part-way (PE-1041).
    */
    stoppedTooltip: 'A decline or cancellation has not finished. Open the bulk order to retry it.',
    /**
    The same for the runs a row marks by its `hasStoppedRun` flag (PE-1050); a delivery has no status of its own.
    */
    stoppedPlacementTooltip: 'A placement has not finished. Open the bulk order to retry it.',
    stoppedApprovalTooltip: 'An approval has not finished. Open the bulk order to retry it.',
    stoppedDeliveryTooltip: 'A delivery has not finished. Open the bulk order to retry it.',
    statuses: {
      Placing: 'Placing',
      AwaitingApproval: 'Awaiting approval',
      Approving: 'Approving',
      Approved: 'Approved',
      Rejected: 'Rejected',
      Cancelling: 'Cancelling',
      Cancelled: 'Cancelled',
      PartiallyDelivered: 'Partially delivered',
      Delivered: 'Delivered',
      Returned: 'Returned',
    },
    filters: {
      searchPlaceholder: 'Search by bulk order ID',
      vendor: 'Vendor',
      status: 'Status',
      dateRange: 'Date range',
      project: 'Project',
      searchProject: 'Search projects',
      searchVendor: 'Search vendors',
      allVendors: 'All vendors',
      allProjects: 'All projects',
      clear: 'Clear filters',
      statusHint: 'Select one or more statuses',
      statusCount: 'Status ({count})',
    },
    // The aggregated approval confirm (S-07.1, PE-966) and what approving says afterwards. Scope
    // copy follows the variation confirm's, so the three scope surfaces read the same (PE-960).
    approval: {
      title: 'Approve bulk order',
      loading: 'Loading what approval will do',
      loadError: "We couldn't load what approval will do.",
      loadRetry: 'Try again',
      advisory: {
        label: 'Advisory',
        lead: 'These sites move their date range to include today. Approval is not blocked.',
        // Where a reason is asked beneath it, the approval waits on that reason (DL-113).
        reasonLead: "These sites' dates will move to include today. Add a reason to approve.",
        site: '{site} ({order}): {fromStart} to {fromEnd} becomes {toStart} to {toEnd}',
        // A row from the server's refusal, which names no order.
        siteDates: '{site}: {fromStart} to {fromEnd} becomes {toStart} to {toEnd}',
      },
      /** The one reason an approval that moves any site's dates asks for (DL-78). */
      dates: {
        reasonLabel: 'Reason',
        reasonPlaceholder: 'Why are these orders outside the site dates?',
        reasonHint: 'This reason is saved to each moved site’s activity log.',
      },
      reductions: {
        title: 'Reductions approved with this bulk order',
        lead: "Each lowers a site's order. Choose once how they change the BOQ.",
        label: 'Do these reductions change the BOQ line rates?',
        required: 'Choose whether the new rates are permanent or for this order only.',
        permanent: {
          label: 'Update the line rates permanently',
          description:
            "Each BOQ line's rate becomes the bulk order's rate for the line's outstanding quantity.",
        },
        thisOrderOnly: {
          label: 'This order only',
          description:
            "Each BOQ line keeps its rate. Only this bulk order's site orders are priced at the bulk rate.",
        },
        total: 'Moves the BOQ line totals by {amount} in all, excl VAT',
      },
      cleared: {
        title: 'Variations already cleared',
        item: '{site}: {item}, approved by {name} on {date}',
      },
      removed: {
        title: 'Items removed by denied variations',
      },
      cascade:
        'Approving cascades to the 1 site order in one action. | Approving cascades to all {count} site orders in one action.',
      cancel: 'Cancel',
      proceed: 'Proceed & approve',
      errors: {
        version:
          'This bulk order changed since you opened it, so it has been reloaded. Check it and approve again.',
        refused: 'The approval did not go through: {reason}',
        refusedGeneric: 'The approval did not go through. The bulk order has been reloaded.',
        runInProgress:
          'Another approval of this bulk order is already running, so it has been reloaded.',
        noResponse:
          'We could not reach the server, so we cannot tell whether the approval went through. The bulk order has been reloaded.',
        other: 'The approval did not go through.',
      },
      progress: {
        title: 'Approving every site order',
        body: "Approving each site's order and creating the payment requests.\nThis usually takes a few seconds, and longer for a large order.",
      },
      approved: {
        title: 'Bulk order approved',
        content: '{reference} and every site order in it are approved.',
      },
    },
    // The decline and cancel confirms (S-07.3, PE-1036): the design's copy with its em dashes
    // removed, and what each says afterwards.
    cancellation: {
      decline: {
        title: 'Decline bulk order',
        body: "Declining this bulk order declines every site's order under it (1 site) and releases each site's BOQ commitment. The bulk order moves to Rejected. | Declining this bulk order declines every site's order under it ({count} sites) and releases each site's BOQ commitment. The bulk order moves to Rejected.",
        // DL-166: denials cancelled every site order, so there is nothing for the decline to count.
        bodyNoSiteOrders: 'Declining this bulk order moves it to Rejected.',
        reasonLabel: 'Reason for declining',
        confirm: 'Decline',
        cancel: 'Cancel',
        progress: {
          title: 'Declining every site order',
          body: "Declining each site's order and releasing its BOQ commitment.\nThis usually takes a few seconds, and longer for a large order.",
        },
      },
      cancel: {
        title: 'Cancel bulk order?',
        body: "Cancelling this bulk order cancels every site's order under it, releases each site's BOQ commitment, and cancels the bulk payment request and its deposit. This can't be undone.",
        warning:
          'A paid deposit automatically raises a Credit Request. The vendor PO is not un-sent automatically, so let the vendor know.',
        reasonLabel: 'Reason for cancelling',
        confirm: 'Yes, cancel',
        cancel: 'No, keep it',
        progress: {
          title: 'Cancelling every site order',
          body: "Cancelling each site's order, its BOQ commitment and the bulk payment request.\nThis usually takes a few seconds, and longer for a large order.",
        },
      },
      reasonHint: 'Required, up to {max} characters',
      reasonCount: '{count} / {max}',
      errors: {
        reasonRequired: 'Enter a reason.',
        reasonTooLong: 'Keep the reason to {max} characters or fewer.',
        version:
          'This bulk order changed since you opened it, so it has been reloaded. Check it and try again.',
        refusedGeneric: 'This did not go through. The bulk order has been reloaded.',
        noResponse:
          'We could not reach the server, so we cannot tell whether this went through. The bulk order has been reloaded.',
        other: 'This did not go through.',
      },
      declined: {
        title: 'Bulk order declined',
        content: '{reference} and every site order in it are declined.',
      },
      cancelled: {
        title: 'Bulk order cancelled',
        content: '{reference} and every site order in it are cancelled.',
      },
      // Who ended the bulk order and when, in the stopped banner and the terminal banner alike.
      attribution: {
        Rejected: 'Declined by {name} · {date}',
        Cancelled: 'Cancelled by {name} · {date}',
        paymentRequestDeclined:
          'Cancelled because payment request {number} was declined by {name} · {date}',
        paymentRequestDeclinedUnnumbered:
          'Cancelled because its payment request was declined by {name} · {date}',
      },
    },
    // Owner completion (S-07.2, PE-1054). Whole-scope copy corrects the design's "keeps the parent
    // Delivered", and the per-child copy drops its em dash.
    completion: {
      eyebrow: 'Bulk order · {reference}',
      title: 'Complete',
      loadError: "We couldn't load what completing will do.",
      loadRetry: 'Try again',
      scope: {
        label: 'Scope',
        whole: 'Whole bulk order',
        child: 'One site order',
        site: 'Site order to complete',
      },
      info: {
        whole: 'Every site order still open is completed, and the bulk order moves to Delivered.',
        child:
          "Only {site}'s site order is completed. The others stay open, and the bulk order moves to Delivered once the last one is completed.",
      },
      table: {
        columns: {
          site: 'Site',
          ordered: 'Ordered',
          delivered: 'Delivered',
          undelivered: 'Undelivered',
          writeOff: 'Removed (excl VAT)',
        },
        expand: 'Show the items for {site}',
        collapse: 'Hide the items for {site}',
      },
      writeOff: {
        title: {
          whole: 'Removed from every site order',
          child: 'Removed from this site order',
        },
        description: {
          whole:
            'What was not delivered comes off each site order. Their BOQs and the bulk payment request are updated to match.',
          child:
            'What was not delivered comes off this site order only. Its BOQ and the bulk payment request are updated to match.',
        },
        exclVat: 'Removed (excl VAT)',
        vat: 'VAT',
        totalInclVat: 'Total removed (incl VAT)',
        settlement: {
          title: 'What happens to it',
          reducesOwed: 'Comes off what is still owed on the bulk payment request',
          creditRequest: 'Raised as a credit request',
          creditRequestNote:
            'What has already been paid cannot be reduced, so it is raised as a credit request. The vendor credit only shows once that credit request is completed.',
        },
      },
      cancel: 'Cancel',
      confirm: {
        whole: 'Complete bulk order',
        child: 'Complete site order',
      },
      progress: {
        whole: {
          title: 'Completing every site order',
          body: 'Removing what was not delivered from each site order and restoring its BOQ.\nThis usually takes a few seconds, and longer for a large order.',
        },
        child: {
          title: 'Completing the site order',
          body: 'Removing what was not delivered and restoring its BOQ.\nThis usually takes a few seconds.',
        },
      },
      completed: {
        whole: {
          title: 'Bulk order completed',
          content:
            '{reference} is completed. What was not delivered is removed from every site order.',
        },
        child: {
          title: 'Site order completed',
          content:
            'One site order on {reference} is completed. What was not delivered is removed from it.',
        },
      },
      // A completion that stopped part-way holds nothing (DL-198 A-02): the dialog's confirm is the
      // retry, and it completes only what is still undelivered.
      partial: {
        headline: 'Completion stopped part way.',
        completed: 'Completed: {sites}',
        failed: 'Not completed: {site}',
        failedWithReason: 'Not completed: {site} ({reason})',
        notStarted: 'Not started: {sites}',
        next: 'Complete again to finish the rest.',
        unnamedSite: 'Site {position}',
      },
      errors: {
        version:
          'This bulk order changed since you opened it, so it has been reloaded. Check it and complete again.',
        refusedGeneric: 'This did not go through. The bulk order has been reloaded.',
        noResponse:
          'We could not reach the server, so we cannot tell whether this went through. The bulk order has been reloaded.',
        other: 'This did not go through.',
      },
    },
    // The recovery surface for a bulk order whose placement stopped part-way (PE-694). It names the
    // same things the confirm does: the site orders already created, and each site's BOQ.
    placementOutcome: {
      label: 'Placement outcome',
      headline: 'This bulk order was only partly placed',
      body: 'Nothing more will be placed until you retry or abandon it, and it cannot be approved until then.',
      abandoningHeadline: 'Abandoning this bulk order stopped before it finished',
      abandoningBody:
        '{cancelled} of {total} site orders are cancelled. Abandon again to finish cancelling the rest.',
      lastAttempt: 'Last attempt {date} at {time}.',
      placed: 'Placed: 1 site | Placed: {count} sites',
      failed: 'Failed: 1 site | Failed: {count} sites',
      notStarted: 'Not started: 1 site | Not started: {count} sites',
      attempts: '1 attempt | {count} attempts',
      unnamedSite: 'Site {position}',
      retry: 'Retry remaining',
      abandon: 'Abandon',
      finishAbandoning: 'Abandon again',
      notices: {
        changed:
          'This bulk order changed since you opened it, so it has been reloaded. Check it and try again.',
        retryFailedAgain:
          'The retry placed what it could, but a site failed again. The details below are up to date.',
        abandonStopped:
          'Some site orders could not be cancelled. The ones below are still open; abandon again to retry them.',
        // No response came back, so whether the request reached the server is unknown: say so rather
        // than claim nothing changed.
        noResponse:
          'We could not reach the server, so we cannot tell whether that went through. Check your connection, then reopen this bulk order before trying again.',
        notAvailable: 'This bulk order is no longer available to you.',
      },
      confirm: {
        title: 'Abandon this bulk order?',
        body: 'This cancels the site order already created and returns its site’s BOQ, then closes the bulk order as cancelled. It cannot be undone. | This cancels the {count} site orders already created and returns each site’s BOQ, then closes the bulk order as cancelled. It cannot be undone.',
        confirm: 'Abandon bulk order',
        cancel: 'Keep it',
      },
      abandoned: {
        title: 'Bulk order abandoned',
        content: 'Its site orders are cancelled and each site’s BOQ is returned.',
      },
      // The same surface for an approval that stopped part-way (PE-966). Roll-forward only: there
      // is no abandon for an approval (DL-159).
      approval: {
        label: 'Approval outcome',
        headline: 'Approval stopped before every site was approved',
        runningHeadline: 'This bulk order is being approved',
        body: 'The approved sites stay approved. Retry approval to finish the rest; no site is approved twice.',
        runningBody:
          'Approval is still running. Reopen this bulk order shortly to see where it got to.',
        viewerBody:
          'The approved sites stay approved. Someone who can approve this bulk order can retry the rest.',
        approved: 'Approved: 1 site | Approved: {count} sites',
        retry: 'Retry approval',
        notices: {
          stoppedAgain:
            'The retry approved what it could, but a site failed again. The details below are up to date.',
          runInProgress:
            'Another approval of this bulk order is already running. The details below are up to date.',
        },
      },
      // The same surface for a decline or cancel that stopped part-way (PE-1041). Roll-forward
      // only: no abandon and no undo. Worded by the outcome the claim persisted, never by the
      // button pressed.
      cancellation: {
        label: 'Cancellation outcome',
        headline: {
          Rejected: 'This decline has not finished',
          Cancelled: 'This cancellation has not finished',
        },
        runningHeadline: {
          Rejected: 'This bulk order is being declined',
          Cancelled: 'This bulk order is being cancelled',
        },
        body: {
          Rejected:
            "The bulk order is not declined yet, because the site orders still live draw on their sites' BOQs. The site orders already declined stay declined, and there is no undo. Retry cancellation to finish the rest.",
          Cancelled:
            "The bulk order is not cancelled yet, because the site orders still live draw on their sites' BOQs. The site orders already cancelled stay cancelled, and there is no undo. Retry cancellation to finish the rest.",
        },
        viewerBody: {
          Rejected:
            "The bulk order is not declined yet, because the site orders still live draw on their sites' BOQs. The site orders already declined stay declined. Someone who can decline this bulk order can retry the rest.",
          Cancelled:
            "The bulk order is not cancelled yet, because the site orders still live draw on their sites' BOQs. The site orders already cancelled stay cancelled. Someone who can cancel this bulk order can retry the rest.",
        },
        // Every site order moved, and closing the bulk order is what stopped (`stage: completion`).
        completionBody: {
          Rejected:
            'Every site order is declined, but closing the bulk order has not finished. The declines already done stay done, and there is no undo.',
          Cancelled:
            'Every site order is cancelled, but closing the bulk order and cancelling its payment requests has not finished. The cancellations already done stay done, and there is no undo.',
        },
        runningBody:
          'This is still running. Reopen this bulk order shortly to see where it got to.',
        reason: {
          Rejected: 'Decline reason: {reason}',
          Cancelled: 'Cancellation reason: {reason}',
        },
        done: {
          Rejected: 'Declined: 1 site | Declined: {count} sites',
          Cancelled: 'Cancelled: 1 site | Cancelled: {count} sites',
        },
        failed: 'Failed: 1 site | Failed: {count} sites',
        notStarted: 'Not started: 1 site | Not started: {count} sites',
        attempts: '1 attempt | {count} attempts',
        failedSite: '{site} ({order})',
        unnamedSite: 'Site {position}',
        lastAttempt: 'Last attempt {date} at {time}.',
        retry: 'Retry cancellation',
        progress: {
          title: 'Finishing the cancellation',
          body: 'Moving the site orders still live and closing the bulk order.\nThis usually takes a few seconds, and longer for a large order.',
        },
        notices: {
          stoppedAgain:
            'The retry finished what it could, but a site failed again. What was already done stays done, and the details below are up to date.',
          runInProgress:
            'This is already being finished elsewhere. The details below are up to date.',
          changed:
            'This bulk order changed since you opened it, so it has been reloaded. Check it and try again.',
          refused: 'The retry did not go through: {reason} The bulk order has been reloaded.',
          refusedGeneric: 'The retry did not go through. The bulk order has been reloaded.',
          noResponse:
            'We could not reach the server, so we cannot tell whether the retry went through. The bulk order has been reloaded to show where it got to.',
          notAvailable: 'This bulk order is no longer available to you.',
        },
      },
      // The same surface for a delivery that stopped part-way (PE-1050). Roll forward only: the
      // goods already logged are real, so the only way out is to finish. Keyed on the parent's run,
      // not its status, since a stopped delivery leaves the parent as it was.
      delivery: {
        label: 'Delivery outcome',
        headline: 'This delivery has not finished',
        runningHeadline: 'This delivery is being logged',
        body: 'The goods logged for {logged} are recorded. Retry to log the remaining {remaining}.',
        bodyNothingLogged: 'No site is logged yet. Retry to log {remaining}.',
        // Every site is logged and closing the delivery is what stopped (`stage: completion`).
        completionBody: 'Every site is logged. Retry to finish this delivery.',
        viewerBody:
          'The goods logged for {logged} are recorded. Someone who can log a delivery on this bulk order can retry the rest.',
        viewerCompletionBody:
          'Every site is logged. Someone who can log a delivery on this bulk order can finish it.',
        runningBody:
          'A delivery is still being logged on this bulk order. Reopen it shortly to see where it got to.',
        sites: '1 site | {count} sites',
        logged: 'Logged: 1 site | Logged: {count} sites',
        failed: 'Failed: 1 site | Failed: {count} sites',
        notStarted: 'Not started: 1 site | Not started: {count} sites',
        attempts: '1 attempt | {count} attempts',
        unnamedSite: 'Site {position}',
        lastAttempt: 'Last attempt {date} at {time}.',
        retryDelivery: 'Retry delivery',
        retryRemaining: 'Retry remaining sites',
        progress: {
          title: 'Finishing the delivery',
          body: 'Logging the delivery on the sites still to take it.\nThis usually takes a few seconds, and longer for a large order.',
        },
        retrying: 'Retrying…',
        notices: {
          stoppedAgain:
            'The retry logged what it could, but a site failed again. The details below are up to date.',
          runInProgress:
            'This delivery is already being finished elsewhere. The details below are up to date.',
        },
      },
    },
    // The bulk delivery log (S-07.4, PE-1046), opened from the hub (PE-1049). Copy is the ticket's,
    // quoted; screen-10's info text, not the design file's.
    deliveryLog: {
      eyebrow: 'Log delivery',
      steps: {
        arrived: 'What arrived',
        allocate: 'Allocate to sites',
      },
      loadError: {
        title: "We couldn't load this bulk order",
        description: 'Check your connection and try again.',
        retry: 'Retry',
      },
      info: {
        first:
          "Enter what arrived on this delivery. Each item's Remaining figure fills in everything still outstanding.",
        later:
          'Enter what arrived on this delivery. Remaining shows only what is still outstanding: 1 site. | Enter what arrived on this delivery. Remaining shows only what is still outstanding: {count} sites.',
      },
      inventory: {
        title: 'Order Inventory',
        subtitle: 'Complete the item quantity and rates delivered.',
        headers: {
          name: 'Item name',
          specification: 'Specification',
          sku: 'SKU',
          remaining: 'Remaining',
          qty: 'Qty',
          rate: 'Rate',
          amount: 'Amount',
        },
        deliveredTotal: 'Delivered Total',
        remaining: '{quantity} remaining',
        remainingTooltip:
          'This order still has {quantity} to be delivered. Click to fill the quantity with it.',
        resetRate: 'Reset to the order rate',
        rateDelta: {
          up: '{amount} above the order rate',
          down: '{amount} below the order rate',
        },
        rateTooltip: {
          title: 'Changing the rate',
          trigger: 'What changing the rate does',
          points: {
            applies: 'Applies to this delivery and all future deliveries on this order.',
            orderTotal: 'Updates the order total.',
            delivered: 'Items already delivered keep their original rate.',
            boq: "Updates this line item's rate in the BOQ.",
          },
        },
        itemCardLabel: 'Delivery of {item}',
        fieldLabel: {
          qty: 'Quantity delivered of {item}',
          rate: 'Rate for {item}',
        },
      },
      documentation: {
        title: 'Order documentation',
        subtitle:
          "Add your proof of this delivery. It is shared to every site's order and to the bulk payment request.",
        label: 'Proof of delivery',
        constraint: 'One PDF or image, up to 10 MB.',
        empty: 'No proof of delivery attached yet.',
        upload: 'Upload',
        typeError: 'Attach a PDF or an image.',
      },
      allocate: {
        tabs: {
          balanced: 'Fully allocated',
          over: '{count} over',
          check: 'Check sites',
        },
        balance: {
          line: '{allocated} of {quantity} {unit} allocated',
          over: '· {count} {unit} over the delivery',
          left: '· {count} {unit} still to allocate',
        },
        tiles: {
          progress: '{done} of {total} items allocated',
          progressLabel: 'Items fully allocated',
          groupLabel: 'Items delivered',
          figure: '{allocated} of {quantity} {unit}',
          left: '{count} to allocate',
        },
        fillOutstanding: 'Fill outstanding',
        clearAll: 'Clear all',
        searchLabel: 'Search sites',
        sitesWithOutstanding:
          '1 site with {item} outstanding | {count} sites with {item} outstanding',
        noMatch: 'No sites match “{query}”.',
        columns: {
          site: 'Site',
          outstanding: 'Outstanding',
          thisDelivery: 'This delivery',
          leftAfter: 'Left after',
        },
        outstandingTooltip: {
          title: 'Outstanding on this order',
          body: 'The quantity of this item ordered for the site that has not been delivered yet.',
        },
        keyboardHint: 'Enter or ↓ moves to the next site.',
      },
      errors: {
        proofMissing: 'Upload proof of delivery to continue.',
        proofInvalid: 'Attach one proof of delivery, a PDF or an image of at most 10 MB.',
        exceedsRemaining: 'Only {qty} left',
        enterQuantity: 'Enter a qty',
        rateNeedsQuantity: 'Needs a qty',
        invalidNumber: 'Enter a rate',
        unbalanced: 'Every item must be fully allocated before you confirm.',
        sitesOver: 'Some sites are allocated more than they have outstanding.',
      },
      footer: {
        next: 'Next',
        back: 'Back',
        confirm: 'Confirm delivery',
        confirming: 'Confirming…',
      },
      progress: {
        title: 'Logging the delivery on every site order',
        body: "Logging each site's share and sharing the proof of delivery.\nThis usually takes a few seconds, and longer for a large order.",
      },
      discard: {
        title: 'Discard this delivery?',
        body: 'Your changes to this delivery will be lost.',
        keep: 'Keep editing',
        confirm: 'Discard',
      },
      run: {
        logged: 'Logged',
        notStarted: 'Not started',
        unnamedSite: 'Site {position}',
      },
      toasts: {
        logged: {
          title: 'Bulk delivery logged',
          content: 'The delivery is recorded on {reference} and on each site order.',
        },
        version: {
          title: 'This bulk order changed since you opened it',
          content: 'What is still outstanding has been reloaded. Enter this delivery again.',
        },
        unconfirmed: {
          title: 'We could not confirm this delivery',
          content:
            'The bulk order changed while it was sending, so it may have been logged. Check what is still outstanding before you log it again.',
        },
      },
    },
    hub: {
      title: 'Bulk Order {reference}',
      titleFallback: 'Bulk order',
      error: "We couldn't reach the bulk order service. Please try again.",
      tabs: { details: 'Details', activityLog: 'Activity Log' },
      // The header's vendor PO icons (PE-1349). Their tooltips and phone menu labels are the order
      // drawer's own (orders.buttons); each icon's accessible name names the bulk order it acts on.
      vendorPo: {
        downloadAccessible: 'Download vendor PO for bulk order {reference}',
        shareVendorAccessible: 'Share bulk order {reference} with vendor',
        shareSelfAccessible: 'Send bulk order {reference} to yourself',
        runInProgress: 'Unavailable while this bulk order is being updated across its sites.',
        noVendorEmail:
          'This vendor has no email address. Add one on the Vendors page to share with them.',
        noVendorEmailSynced:
          'This vendor has no email address. Ask BOQNET support to add one to share with them.',
        toasts: {
          downloaded: {
            title: 'Vendor PO downloaded',
            content: 'The purchase order for {reference} has been saved.',
          },
          sharedWithVendor: {
            title: 'Bulk order shared with vendor',
            content: '{vendor} has been emailed the purchase order for {reference}.',
          },
          sentToYou: {
            title: 'Bulk order sent to you',
            content: 'The purchase order for {reference} has been emailed to you.',
          },
        },
      },
      tiles: { orderTotal: 'Order total (incl VAT)', sites: 'Sites', owner: 'Owner' },
      /**
      Terminal-state reasons, read from the persisted outcome (PE-1036). Both read red.
      */
      terminalReason: {
        label: {
          Rejected: 'Decline reason',
          Cancelled: 'Cancellation reason',
        },
        // Ended with no outcome recorded: an abandoned placement, or a parent from before PE-1033.
        unrecorded: {
          Rejected: 'This bulk order was declined.',
          Cancelled: 'This bulk order was cancelled.',
        },
      },
      footer: {
        approve: 'Approve',
        approveAccessible: 'Approve bulk order',
        decline: 'Decline',
        declineAccessible: 'Decline bulk order',
        cancel: 'Cancel bulk order',
        cancelAccessible: 'Cancel bulk order',
        logDelivery: 'Log a delivery',
        logDeliveryAccessible: 'Log a delivery on bulk order',
        complete: 'Complete',
        completeAccessible: 'Complete bulk order',
        blockedReason: '1 variation still needs approval | {count} variations still need approval',
        // A list row carries the blocked flag but not the variations, so it cannot count them.
        blockedReasonUncounted: 'Variations still need approval',
        noSiteOrders: 'No site orders remain to approve',
        cancelAwaitingProof:
          '{payment} is awaiting proof for this bulk order. Upload its proof or cancel the payment first.',
        cancelAwaitingProofNoLogPayment:
          '{payment} is awaiting proof for this bulk order. Someone who logs payments must upload its proof or cancel it first.',
        dismissReason: 'Dismiss',
      },
      // DL-166: denials cancelled every site's order, which leaves nothing for approval to cascade
      // to. The bulk order waits for B.4's decline.
      noSiteOrders:
        'Every site order on this bulk order has been cancelled by a denied variation, so no site orders remain to approve.',
      // The hub's variations list (PE-962). Gating increases block the bulk order's approval;
      // reductions do not, and are approved with the bulk order (DL-149).
      variations: {
        title: 'Variations',
        subtitle: 'Increases block approval until each is resolved on its own site',
        approve: 'Approve',
        // Mobile only: the desktop table's deny is an icon-only button, where a card's footer has
        // the room to say what it does. "Deny", not "Decline": the bulk order's own Decline is a
        // different action.
        deny: 'Deny',
        approveOne: 'Approve variation on {site}',
        denyOne: 'Deny variation on {site}',
        gating: 'Blocks approval',
        nonGating: 'Approved with the bulk order',
        columns: {
          site: 'Site',
          item: 'Item',
          approval: 'Approval',
          rateChange: 'Rate',
          quantityChange: 'Qty',
          totalChange: 'Total change',
        },
        // Says the row's figure is this order's movement on the line, not the permanent one,
        // which only the confirm shows (DL-167 A-12).
        totalCaption: 'This order',
        // Only where the read carries no this-order figure: what approving moves the line by.
        totalCaptionApproved: 'When approved',
        outstanding: '{quantity} outstanding',
        noChange: 'No change',
      },
      // What a denied variation removed (DL-155). Not dismissible, for the same reason as the
      // terminal banner (DL-62).
      changeNotices: {
        removed:
          '{site}: {item} was removed by a denied variation ({quantity} units, {amount} excl VAT).',
        removedAndCancelled:
          "{site}: {item} was removed by a denied variation ({quantity} units, {amount} excl VAT). It was the site's only line, so that site's order was cancelled.",
        total: 'The bulk order total is now {total} incl VAT.',
      },
      subOrderBlockedTooltip: 'Blocked: a variation on this site needs approval',
      summary: {
        title: 'Bulk order summary',
        subtitle: 'Project, vendor and order-level total',
        vendorName: 'Vendor name',
        vendorAccountType: 'Vendor account type',
        // The figure above is the served `totalInclVat`, so the footnote says so.
        totalFootnote: 'Aggregated across {count} sub-orders, incl VAT.',
        // A decline or cancellation zeroes the live total, so the figure shown is from when it began.
        totalFootnoteEnded: {
          Rejected: 'The total when it was declined, across {count} sub-orders, incl VAT.',
          Cancelled: 'The total when it was cancelled, across {count} sub-orders, incl VAT.',
        },
        project: 'Project',
        vendor: 'Vendor',
        owner: 'Created by',
        created: 'Created',
        total: 'Bulk order total',
        // Incl VAT, as the total above and the requests below are, so it says so.
        amountPaid: 'Amount paid incl VAT',
        // Under that label once something has been credited back; the rows read as its figures.
        paidBreakdown: { paid: 'Paid', creditedBack: 'Credited back', netPaid: 'Net paid' },
        vendorNotified: 'Vendor notified',
        notifiedYes: 'Yes',
        notifiedNo: 'No',
      },
      // The Summary's list of the bulk order's payment requests and bulk credits (PE-1167).
      requests: {
        title: 'Payment requests and credits',
        number: 'Number',
        typeHeader: 'Type',
        status: 'Status',
        amount: 'Amount incl VAT',
        // DL-233 A-03 names these four; a refund reads Credit.
        type: {
          deposit: 'Deposit',
          payment: 'Payment',
          adjustment: 'Adjustment',
          credit: 'Credit',
        },
        // Where the requests will appear, until there are any (DL-227 item 11).
        beforeApproval: 'Payment requests are raised when the bulk order is approved.',
      },
      documents: {
        // Matched to the orders/claims drawer, which splits its documents into these same two
        // accordions with these same titles. The subtitles are bulk's own, because what a bulk
        // parent holds and where the rest lives is specific to it.
        key: {
          title: 'Key documentation',
          subTitle:
            'All documents required for the completion of this bulk order and its associated payments.',
          // PE-1049, verbatim: a bulk order's GRN comes only from its own delivery log (ADR-017).
          proofOfDeliveryNote:
            "Proof of delivery is added when you log a delivery on this bulk order, and is shared to every site's order.",
        },
        additional: {
          title: 'Additional documentation',
          subTitle: 'Additional documentation added or generated through this bulk order.',
          // The label beside the Upload control, and the empty line beneath it — the same shape
          // the orders drawer's own Additional panel uses.
          uploadTitle: 'Bulk order documentation',
          noDocumentation: 'No documentation added',
        },
        // A document that came up from a site's order (a GRN) can only be removed where it was added.
        deleteElsewhere: '{name} was added on a site’s order. Delete it from that order.',
        deleteConfirm: {
          title: 'Delete this document?',
          body: '{name} will be removed from this bulk order and from every site order it was shared with.',
          confirm: 'Delete',
          cancel: 'Cancel',
        },
      },
      subOrders: {
        // Names the dash a total column shows when the child's amount is absent — read by
        // assistive tech only, since a dash beside real figures is unambiguous on screen.
        noTotal: 'No total available',
        title: 'Linked sub-orders',
        subtitle: 'Select a site to view its order',
        count: '{count} sites',
        site: 'Site',
        status: 'Status',
        items: 'Items',
        total: 'Total incl VAT',
        quantity: 'Quantity',
      },
    },
    /**
    S-02 / S-08: the child's view of its parent.
    */
    child: {
      partOf: 'Part of bulk order {reference}',
      partOfShort: 'Part of {reference}',
      /**
      PE-1221 (from DL-236 D-04): a child's Payment column on the Orders list, in place of its
      payment requests. View's accessible name, and the text for a viewer who may not open the hub.
      */
      viewPayments: 'View payment requests on bulk order {reference}',
      bulkOrderPayment: 'Bulk order',
      viewBulkOrder: 'View bulk order',
      bulkTag: 'Bulk',
      /**
      DL-65: a bulk child in `Requested` says whose approval it is waiting on.
      */
      awaitingBulkApproval: 'Awaiting bulk approval',
      cascadedApproval: 'Approval is cascaded from the parent bulk order',
      /**
      The band's second line, on every bulk child for every viewer (ADR-017, PE-1039).
      */
      deliveriesLoggedOnBulk: 'Deliveries are logged on the bulk order.',
      /**
      In place of a Key documentation row's upload, for a type the bulk order holds (FR-61).
      */
      heldOnBulkOrder: 'Already on bulk order {reference}',
      /**
      The delivery note row, before the bulk order holds one: a site order never takes one (DL-219).
      */
      deliveryNotesOnBulkOrder: 'Logged on bulk order {reference}',
      /**
      The footer message once a child is approved and has no action of its own left.
      */
      managedOnBulk: 'Deliveries and completion are handled on the bulk order.',
      createdBy: 'Created by {name}',
      /**
      FR-36: a declined or cancelled child shows the parent's reason, and says whose it is.
      */
      declineReasonHeading: 'Reason for declining: from the parent bulk order',
      cancelReasonHeading: 'Reason for cancelling: from the parent bulk order',
      declinedOnParent: 'Declined on the parent bulk order: {reason}',
      declinedOnParentBy: 'Declined on the parent bulk order by {name}: {reason}',
      cancelledOnParent: 'Cancelled on the parent bulk order: {reason}',
      cancelledOnParentBy: 'Cancelled on the parent bulk order by {name}: {reason}',
    },
    tiles: {
      readyToApprove: {
        label: 'Ready to approve',
        meaning: 'Placed bulk orders awaiting your approval with no unresolved variations.',
      },
      blockedByVariation: {
        label: 'Blocked by variation',
        meaning:
          "Placed bulk orders that can't be approved until an over-budget site variation is cleared.",
      },
      inDelivery: {
        label: 'In delivery',
        meaning: 'Approved bulk orders being delivered across their sites.',
      },
      /**
      Names the count and what activating the tile does — a bare figure is not usable.
      */
      accessibleName: '{label}: {count} bulk orders. {meaning} Activate to filter the list.',
    },
  },
};
